/**
 * JobStore serves as a cache for the list of jobs returned by the dataService
 * and is responsible to transform this data into the format expected by the view.
 * @param dataService must have a function fetchJobs
 */
export const JobStore = function(dataService) {
  var localJobs;

  function toViewModel(job) {
    return job;
  }

  /**
   * Returns a promise that resolves to an array of job objects:
   * [{
   *  title,
      employer,
      employerUrl,
      startDate,
      endDate,
      sector,
      location,
      description,
      skills,
      highlights,
   * }]
   */
  function getJobs() {
    if (localJobs) {
      return Promise.resolve(localJobs);
    }
    return dataService.fetchJobs().then(result => {
      localJobs = result.map(toViewModel);
      return localJobs;
    });
  }

  return Object.freeze({
    getJobs
  });
};
